import styled from 'styled-components/native'
import { ProximaNova } from '../App/Components/TextComponent'

export const ErrorContainer = styled.View`
  width: 100%;
  padding: 20px;
  align-items: center;
`

export const ErrorHeading = styled(ProximaNova)<{ fontcolor: string }>`
  color: ${({ fontcolor }) => fontcolor};
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 12px;
`

export const ErrorMessage = styled(ProximaNova)<{ fontcolor: string }>`
  color: ${({ fontcolor }) => fontcolor};
  text-align: center;
  margin-bottom: 16px;
  line-height: 22px;
`

export const ErrorContext = styled(ProximaNova)<{ fontcolor: string }>`
  color: ${({ fontcolor }) => fontcolor};
  opacity: 0.5;
  font-size: 12px;
  text-align: center;
`
